'use client';

import { cn } from '@core/utils';
import { useState } from 'react';

import { Image } from '@/components/client';

interface ThumbnailBackedImageProps {
  src: string;
  alt: string;
  thumbnailSrc?: string;
  loading?: 'eager' | 'lazy';
  preload?: boolean;
  fetchPriority?: 'high' | 'low' | 'auto';
}

//* 목록이 이미 받은 썸네일을 바닥에 깔고 히어로 해상도는 로드 뒤 페이드로 덮는다 — CDN 엣지 미스(0.3~0.5s) 동안 회색 대신 사진이 보인다
export const ThumbnailBackedImage = ({
  src,
  alt,
  thumbnailSrc,
  loading,
  preload,
  fetchPriority,
}: ThumbnailBackedImageProps) => {
  const [isHeroLoaded, setIsHeroLoaded] = useState(false);

  return (
    <>
      {thumbnailSrc ? (
        <Image
          src={thumbnailSrc}
          alt=""
          fill
          unoptimized
          className="object-cover"
          loading="eager"
        />
      ) : null}
      <Image
        src={src}
        alt={alt}
        fill
        unoptimized
        loading={loading}
        preload={preload}
        fetchPriority={fetchPriority}
        className={cn(
          'object-cover',
          thumbnailSrc && 'transition-opacity duration-200',
          thumbnailSrc && !isHeroLoaded && 'opacity-0',
        )}
        onLoad={() => setIsHeroLoaded(true)}
      />
    </>
  );
};
